module.exports = Object.freeze({
    "ISO_TODAY": "$_ISO_TODAY",
    "ISO_NOW": "$_ISO_NOW",
    "UNIX_TODAY": "$_UNIX_TODAY",
    "UNIX_NOW": "$_UNIX_NOW",
    "UNIXMILLISEC_TODAY": "$_UNIXMILLISEC_TODAY",
    "UNIXMILLISEC_NOW": "$_UNIXMILLISEC_NOW"
});